import moment from 'moment';

export default function formatDateAndTimeToISO(date, time) {
  const formattedDate = moment(date).format('L');
  const formattedTime = moment(time).format('LT');

  return new Date(`${formattedDate} ${formattedTime} UTC`).toISOString();
}
